import '../../../grjs7/dist/gr_reco7';
import { init, getItemId, hashString } from '../../init';
import template from './html/template.html';

const PATHNAME_GROUP = "shopping";
const PATHNAME_SUBGROUP = "article";
const PUBLISHER_ID = "1594367";
const PLACEMENT_SELECTORS = ["#taboola-feed-container"];
const ADVERTISER_ID = "1561653";
const TFA_URL = "//cdn.taboola.com/libtrc/unip/"+ADVERTISER_ID+"/tfa.js";
window._tfa = window._tfa || [];
window._tfa.push({notify: 'event', name: 'page_view', id: ADVERTISER_ID});
!function (t, f, a, x) {
       if (!document.getElementById(x)) {
          t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
       }
}(document.createElement('script'), document.getElementsByTagName('script')[0],TFA_URL,'tb_tfa_script');

// can be beforeend, afterend, beforebegin, afterbegin
// https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
const PLACEMENT_TARGET = 'afterbegin';

const NUMBER_LIMIT_FOR_RECOMMENDABLE_ITEMS = 6;
const PLACEMENT_UNIQUE_ID = 'GR_PLACEMENT_4808064';
const SCENARIO_ID = 'ECREC';
const PROPERTY_LIST = ["url", "itemid", "imageUrl", "ogtitle", "description"];
const TEMPLATE = template;
const GROUP_ID = "ARTICLES_GROUP";

function isRecommendationEnabled() {
    // URL is not /shopping/... but starts with /shopping/
    // URL should only be /shopping/article/... and not /shopping/...
    const currentPathName = window.location.pathname;
    const strippedCurrentPathName = window.location.pathname.replaceAll("/", "");
    return strippedCurrentPathName !== PATHNAME_GROUP && currentPathName.indexOf(PATHNAME_SUBGROUP) !== -1 && currentPathName.startsWith('/' + PATHNAME_GROUP);
}

/**
    @param {string} containerSelector - The selector of the container where the recommendation box will be placed
    @param {string} targetPosition - The position where the recommendation box will be placed
    @param {string} placementId - The id of the placement that should be unique
    @param {string} scenarioId - The id of the scenario for recommendation LOGIC
    @param {string[]} resultNames - Parameter list for RECO to give values for
    @param {number} numberLimit - How many items should be recommended by reco
    @param {string} template - The template of the recommendation box
    @param {number} groupSize - The size of the group  TODO: can be calculated from the length of the PLACEMENT_DATA
    @param {number} groupSeq - The sequence of the group  TODO can be calculated from the index of the PLACEMENT_DATA
    @param {string} groupId - The id of the group that it's useful for grouping the PLACEMENT_DATA item
    @param {string} elementToHide - The element that should be hidden if the recommendation box is NOT empty
*/
const PLACEMENT_1 = [
    PLACEMENT_SELECTORS[0],
    PLACEMENT_TARGET,
    PLACEMENT_UNIQUE_ID,
    SCENARIO_ID,
    PROPERTY_LIST,
    NUMBER_LIMIT_FOR_RECOMMENDABLE_ITEMS,
    TEMPLATE,
    1,
    1,
    GROUP_ID
]

const PLACEMENT_DATA = [
    PLACEMENT_1
];

const CSS_OVERRIDE = `
        #taboola-feed-container {
            margin-top: 2rem !important;
        }
    `;

function carousel(carouselElement, recommendationCount) {
    if (!carouselElement || recommendationCount <= 0) {
        console.log('No carousel element or recommendation count is 0');
        return;
    }

    const sectionWrapperElement = carouselElement.querySelector(".gr-content-wrapper");
    const recoBox = sectionWrapperElement.closest('.recommendation-box-container');

    let isReachedRightEnd = false;
    let isReachedLeftEnd = false;

    let pagination = `<div class="tbl-pagination">`;

    // insert pagination circles html recommendationCount
    for (let i = 0; i < recommendationCount; i++) {
        pagination += `<div class="tbl-pagination-circle">
                <div class="tbl-pagination-circle-inner"></div>
            </div>`;
    }

    pagination += '</div>'

    // insert pagination into containerSelector
    carouselElement.insertAdjacentHTML('beforeend', pagination);

    let items = carouselElement.querySelectorAll("[data-yuspitemid]");
    items = Array.prototype.slice.call(items);

    let circles = carouselElement.getElementsByClassName('tbl-pagination-circle');
    circles = Array.prototype.slice.call(circles);

    circles.forEach(function(circle, index) {
        circle.addEventListener('mousedown', function() {
            items[index].scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            });
        });
    });

    let arrowLeft = carouselElement.querySelector('.gr-slider-arrow.gr-slider-arrow-prev');
    let arrowRight = carouselElement.querySelector('.gr-slider-arrow.gr-slider-arrow-next');

    // Observer configuration
    const paginationObserverOptions = {
        root: carouselElement,
        rootMargin: '0px',
        threshold: 0.8 // Customize based on your requirement
    };

    // Callback function to handle intersection changes
    function handleIntersection(entries, observer) {
        let intersecting = entries.filter(entry => entry.isIntersecting);

        if (intersecting.length === items.length) {
            arrowLeft.style.display = 'none';
            arrowRight.style.display = 'none';
            recoBox.classList.remove("gr-only-left");
            recoBox.classList.remove("gr-only-right");
            return;
        }

        for (let i = 0; i < entries.length; i++) {
            let entry = entries[i];
            let itemIndex = items.findIndex(item => item == entry.target);

            if (entry.isIntersecting) {
                entry.target.classList.add('is-active');
                circles[itemIndex].classList.add('is-active');
            } else {
                entry.target.classList.remove('is-active');
                circles[itemIndex].classList.remove('is-active');
            }

            if (itemIndex === 0) {
                if (entry.isIntersecting) {
                    arrowLeft.classList.add("gr-slider-arrow-disabled");
                    recoBox.classList.remove("gr-only-left");
                    recoBox.classList.add("gr-only-right");
                } else {
                    arrowLeft.classList.remove("gr-slider-arrow-disabled");
                }
            }

            if (itemIndex === items.length - 1) {
                if (entry.isIntersecting) {
                    arrowRight.classList.add("gr-slider-arrow-disabled");
                    recoBox.classList.remove("gr-only-right");
                    recoBox.classList.add("gr-only-left");
                } else {
                    arrowRight.classList.remove("gr-slider-arrow-disabled");
                }
            }
        }
    };

    // Create the observer
    const observer = new IntersectionObserver(handleIntersection, paginationObserverOptions);

    // Observe each list item
    items.forEach(function (item) {
        observer.observe(item);
    });

    if (!!arrowLeft) {
        arrowLeft.addEventListener('click', function(event) {
            recoBox.classList.add("gr-only-right");
            recoBox.classList.remove("gr-only-left");

            event.stopPropagation();

            if (isReachedLeftEnd){
                return;
            }

            let activeIndex = items.findIndex(item => item.classList.contains('is-active'));

            if (activeIndex > 0) {
                items[activeIndex - 1].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "start"
                });
            }
        });
    }

    if (!!arrowRight) {
        arrowRight.addEventListener('click', function(event) {
            recoBox.classList.add("gr-only-left");
            recoBox.classList.remove("gr-only-right");

            event.stopPropagation();

            if (isReachedRightEnd) {
                return;
            }

            let visibleItems = items.filter(item => item.classList.contains('is-active'));
            let lastVisibleItem = visibleItems[visibleItems.length - 1];
            let activeIndex = items.findIndex(item => item === lastVisibleItem);

            if (activeIndex < items.length - 1) {
                items[activeIndex + 1].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "end"
                });
            }
        });
    }
}

async function sendTaboolaUserId() {
    const taboolaUserId = localStorage.getItem("taboola global:user-id");
    if (!taboolaUserId || taboolaUserId === null) {
        setTimeout(sendTaboolaUserId, 1000);
    } else {
        const hashedId = await hashString(taboolaUserId, "SHA-256");
        const gravity = window._gravity || [];
        gravity.push({
            type: "set",
            taboolaUserId: hashedId,
        });
        gravity.push({
            type: "user",
            userId: hashedId,
        });
        const recId = document.getElementById(PLACEMENT_UNIQUE_ID).getAttribute("data-yusp-recid");
        gravity.push({
            type: "event",
            eventType: "TABOOLA_TO_COOKIEID",
            ...(recId && { recId: recId }),
        });
    };
}

function customScriptAfter() {
    window._tfa = window._tfa || [];
    getItemId().then((itemId) => {
        window._tfa.push({notify: 'ecevent', name: 'product_view', id: ADVERTISER_ID, productIds: [itemId]}); 
    });
    sendTaboolaUserId().then();
}

function initCallback() {
     /**
        @param {function Boolean} isRecommendationEnabled - Function that returns a boolean value whether the recommendation should be enabled or not
        @param {string} PUBLISHER_ID - Prefix for itemIds and value for Advertiser ID
        @param {Array} PLACEMENT_DATA - Recommendation details
        @param {string} initCallback - Function for intialization in case of navigation with SPA
        @param {string} CSS_OVERRIDE - CSS for adjustemnts on Publisher page elements
        @param {boolean} isInsertCSSReset - whether to insert CSS reset for recommendation box, default is true
        @param {customCarousel} function - unique full functionality for carousel
        @param {customScriptAfter} function - customScript at the after recommendation
        @param {customScriptBefore} function - customScript at the beginning of the init function
        @param {disabledRecommendationAfterScript} function - customScript for disabled recommendation
    */
    init(isRecommendationEnabled, PUBLISHER_ID, PLACEMENT_DATA, initCallback, CSS_OVERRIDE, true, carousel, customScriptAfter);
};

initCallback();
